export function convertWidthInMeterToDents(widthInMeter: number, reedDensityInDentsPerMeter: number, marginInDents: number): number {
  return Math.round(widthInMeter * reedDensityInDentsPerMeter + marginInDents);
}
